module.exports = __webpack_public_path__ + "static/img/8.f4bada8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/2/1/sp/8.png
// module id = C5g5
// module chunks = 0